<template>
  <div>
    <vm-table
        ref="vmTable"
        height="80vh"
        :filter.sync="filter"
        module="basic"
        url="grCableparameterses">
      <template slot="adSearch">
        <!-- <div class="vm-search">
          <vm-search label="工号">
            <el-input v-model.trim="filter.clientContractNo" clearable/>
          </vm-search>
          <vm-search label="PC号">
            <el-input v-model.trim="filter.workerNo" clearable/>
          </vm-search>
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.startTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endTime"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 165px"
                  placeholder="选择结束时间"/>
            </div>
          </vm-search>
          <vm-search label="柜体条码">
            <el-input v-model.trim="filter.barCode" clearable/>
          </vm-search>
        </div> -->
      </template>
      <el-table-column
          fixed
          prop="customerName"
          align="center"
          label="客户名称"/>
      <el-table-column
          fixed
          prop="cableType"
          align="center"
          label="电缆类型"/>
      <el-table-column
          fixed
          prop="linkDefinition"
          align="center"
          label="电缆连接定义"/>
      <el-table-column
          fixed
          prop="insulationTest"
          align="center"
          label="导通绝缘测试"/>
      <el-table-column
          fixed
          prop="testResult"
          align="center"
          label="测试结果"/>
      <el-table-column prop="factoryNo" align="center" label="出厂编号"/>
      <el-table-column prop="workerNo" align="center" label="广日工号"/>
      <el-table-column prop="cableName" align="center" label="线缆名称"/>
      <el-table-column prop="creatorTime" align="center" label="测试时间"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import KeyComponentEdit from "@/views/information/KeyComponent/KeyComponentEdit";
  export default {
    name: "",
    components: {VmTable},
    data() {
      return {
        idList: "",
        filter: {
          // barCode: "",
          // clientContractNo: "",
          // workerNo: "",
          // startTime: "",
          // endTime: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
    },
  };
</script>

<style scoped>

</style>
